module.exports = __webpack_public_path__ + "media/src/assets/Images/Seriousness-48972e2bb5a1b536abd4057dbe6c687b.svg";